export default __webpack_public_path__ + "static/media/logom.68d336a4.svg";